import React from 'react';
import { Box, Container, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HeaderTable, useRouteScreenTitle } from 'src/commons';
import { grey } from 'src/theme/colors';

const useStyles = makeStyles(() => ({
  paper: {
    padding: 32,
    borderRadius: 12,
    border: `1px solid ${grey.dividers}`,
  },
  description: {
    marginTop: 12,
    color: grey.textSecondary,
  },
}));

type ModulePlaceholderProps = {
  title: string;
};

export const ModulePlaceholder = ({ title }: ModulePlaceholderProps) => {
  const classes = useStyles();

  useRouteScreenTitle(title);

  return (
    <Container maxWidth="lg">
      <Box py={2}>
        <HeaderTable title={title} />
        <Paper elevation={0} className={classes.paper}>
          <Typography variant="h6">{title}</Typography>
          <Typography className={classes.description}>
            Este módulo todavía no tiene una vista implementada.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};
